import { request } from "../utils/request.js"


export const extField_addNew = (pojo, args) => request({
    url: 'extField/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const extField_update = (pojo, args) => request({
    url: 'extField/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const extField_findPageForManage = (pojo, args) => request({
    url: 'extField/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const extField_findAvailableList = (extFieldEntityTypeEnum, args) => request({
    url: 'extField/findAvailableList',
    method: 'GET',
    params: { extFieldEntityTypeEnum },
    showFailMessage: false,
    showSuccessMessage: false,
    ...args
})

export const extField_flushAvailableCache = (args) => request({
    url: 'extField/flushAvailableCache',
    method: 'GET',
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const extField_findById = (id, args) => request({
    url: 'extField/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const extField_changeFrozenStatus = (id, args) => request({
    url: 'extField/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const extField_deleteById = (id, args) => request({
    url: 'extField/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/extField.js